import {Localisation} from "./localisation";
import {CSSProperties, ReactElement} from "react";
import {THEME} from "@components/core/theme";

const styles = {
    text: {
        ...THEME.text
    }
};

interface ILocalisedTypography {
    content?: string
    children?: ReactElement | ReactElement[]
    params?: any
    style?: CSSProperties
}
export function LocalisedTypography(props: ILocalisedTypography) {
    const {content, params, ...typography} = props;
    const key = content || props.children;
    const style = {...styles.text, ...props.style}

    if (typeof key === "string") {
        const text = Localisation.GetText(key, params);

        return <span {...typography} style={style}>{text}</span>
    }
    return (
        <span {...props} style={style}>{props.children}</span>
    );
}